import { createSelector } from "reselect";

/**
 * Direct selector to the login state domain
 */

const selectPaginationDomain = state => state.pagination;

export const createMakeSelectPaginationDomain = key => () =>
  createSelector(selectPaginationDomain, substate => {
    if (!substate[key]) {
      return {
        currentPageNumber: 0,
        rowCount: 0,
        pageCount: 0,
        pageSize: 0,
        pages: new Map()
      };
    }
    return substate[key];
  });

export const createMakeSelectCurrentPage = paginationKey => () =>
  createSelector(
    createMakeSelectPaginationDomain(paginationKey)(),
    substate => {
      if (substate) {
        return substate.pages.get(substate.currentPageNumber) || [];
      }

      return [];
    }
  );
